import { kebabCase } from 'lodash'
import apiClient from './axios'
import IBAN from 'iban'

export const emailRule = {
  pattern: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
  message: 'Lütfen geçerli bir e-posta adresi giriniz',
}

export const webSiteRule = {
  pattern: /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/,
  message: 'Lütfen geçerli bir website adresi giriniz',
}

export const phoneRule = {
  pattern: /0\d{3} \d{3} \d{4}/,
  message: "Lütfen '0' alan koduyla başlayan geçerli bir telefon numarası giriniz.",
}

export const kepEmailRule = {
  pattern: /^[^@\s]+(@[^@\s]+\.kep\.tr|@kep\.tr)$/,
  message: 'Lütfen geçerli bir KEP adresi giriniz (tuzelkisi@kurumadi.hs03.kep.tr)',
}

export const addressRule = {
  pattern: /^.{5,}$/,
  message: 'Adres alanı en az 5 karakter olmalıdır.',
}

export const postalCodeRule = {
  pattern: /\d{5}/,
  message: 'Lütfen posta kodunu 5 haneli sayı olarak giriniz',
}

export const mersisRule = {
  pattern: /\d{16}/,
  message: 'Lütfen 16 haneli MERSİS Numaranızı giriniz',
}

export const registerNoRule = {
  pattern: /\d{6}/,
  message: 'Lütfen 6 haneli Ticari Sicil Numaranızı giriniz',
}

export const tcNoRule = isPersonalCompany => ({
  pattern: isPersonalCompany ? /\d{11}/ : /\d{10}/,
  message: isPersonalCompany
    ? 'Lütfen 11 haneli T.C. kimlik numaranızı giriniz'
    : 'Lütfen 10 haneli vergi numaranızı giriniz',
})

export const passwordRule = ({ getFieldValue }) => ({
  validator: (_, value) =>
    new Promise((resolve, reject) => {
      // pattern: /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){8,16}$/, old regex
      if (/^[\S]{6,16}$/.test(value) && getFieldValue('maazaName') !== value) resolve()
      else if (getFieldValue('maazaName') === value && value)
        reject(new Error('Şifreniz mağaza adınız ile aynı olamaz!'))
      else
        reject(
          new Error(
            'Şifreniz en az 6, en fazla 16 karakter uzunluğunda olmalı, boşluk bulunmamalıdır.',
          ),
        )
    }),
})

export const accountNumberRule = {
  pattern: /^[1-9][0-9]{4,19}$/,
  message:
    'Lütfen hesap numarasını sıfırlarla başlamamak kaydıyla en az 5, en fazla 20 rakam olacak şekilde giriniz',
}

export const stockCodeRule = {
  pattern: /^[a-zA-Z0-9üğşçöıÜĞİŞÇÖ\-][a-zA-Z0-9üğşçöıÜĞİŞÇÖ.\- ]*[a-zA-Z0-9üğşçöıÜĞİŞÇÖ\-]$/,
  message:
    'Lütfen en fazla 30 karakter uzunluğunda yalnızca rakamlardan ve harflerden oluşan bir stok kodu giriniz.',
}

export const branchCodeRule = {
  pattern: /\d{5}/,
  message: 'Lütfen şube kodunu 5 haneli olarak giriniz',
}

export const maazaNameValidator = (_, value, forUpdate) =>
  new Promise((resolve, reject) => {
    if (!value || value.trim() === '') {
      return resolve() // Boş değer için hata fırlatma
    }

    if (
      !/^[a-zA-Z0-9üğşçöıÜĞİŞÇÖ][a-zA-Z0-9üğşçöıÜĞİŞÇÖ.\- ]*[a-zA-Z0-9üğşçöıÜĞİŞÇÖ]$/.test(value) ||
      !kebabCase(value)
    ) {
      return reject(new Error('Lütfen mağaza adınızı kurallara uygun biçimde giriniz'))
    }

    const errorMessage =
      'Mağaza adınız veya karşılık gelen mağaza linki kullanımdadır. Lütfen farklı bir ad deneyin'

    return apiClient
      .post(
        `MerchantAppeals/MerchantAppealMaazaNameAndSlugControl${forUpdate ? 'ForUpdate' : ''}`,
        {
          maazaName: value,
          slug: kebabCase(value),
        },
      )
      .then(response => {
        if (response.data.result) {
          resolve()
        } else {
          reject(new Error(errorMessage))
        }
      })
      .catch(() => {
        reject(new Error('Bir bağlantı hatası oluştu'))
      })
  })

export const companyEmailCheckValidator = (_, value, forUpdate) =>
  new Promise((resolve, reject) => {
    if (value && value.trim() !== '') {
      if (emailRule.pattern.test(value)) {
        const errorMessage =
          'Bu şirket e-posta adresi kullanımdadır. Lütfen farklı bir e-posta adresi deneyin'
        apiClient
          .post(`MerchantAppeals/MerchantAppealEmailControl${forUpdate ? 'ForUpdate' : ''}`, {
            email: value,
          })
          .then(response => {
            if (response.data.result) resolve()
            else reject(new Error(errorMessage))
          })
          .catch(() => reject(new Error('Bir bağlantı hatası oluştu')))
      } else reject(new Error(emailRule.message))
    } else reject()
  })

export const IBANValidator = (_, value) =>
  new Promise((resolve, reject) => {
    if (value && value.trim() !== '') {
      if (!value.startsWith('TR')) {
        reject(new Error("IBAN numarası Türkiye'deki bir hesaba ait olmalıdır."))
      } else if (!IBAN.isValid(value)) {
        reject(new Error('Geçersiz IBAN numarası'))
      } else resolve()
    } else reject()
  })

export const passwordChecker = ({ getFieldValue }) => ({
  validator: (_, value) =>
    new Promise((resolve, reject) => {
      if (!value || getFieldValue('password') === value) resolve()
      else reject(new Error('Şifreler uyuşmuyor!'))
    }),
})

export const otherEcommerceSitesValidator = (_, values) =>
  new Promise((resolve, reject) => {
    if (!values || values.length === 0) {
      reject(new Error('Lütfen en az bir site ekleyin veya seçimi kaldırın.'))
    } else resolve()
  })

export const editorValidator = (_, value, errorMessage) =>
  new Promise((resolve, reject) => {
    const txt = document.createElement('textarea')
    txt.innerHTML = value
    if (
      !txt.value ||
      !txt.value.trim() ||
      !txt.value
        .trim()
        .replace(/<\/?[^>]+(>|$)/g, '')
        .trim()
    ) {
      reject(new Error(errorMessage))
    } else resolve()
  })

export const imageListValidator = (_, images) =>
  new Promise((resolve, reject) => {
    if (!images || images.length === 0) {
      reject(new Error('En az 1 resim yüklenmelidir.'))
    } else if (!images.includes(undefined) && new Set(images).size < images.length) {
      reject(new Error('Aynı resimden birden çok eklenemez.'))
    } else resolve()
  })

export const tagsWhitespaceValidator = (_, value) =>
  new Promise((resolve, reject) => {
    const whiteSpace = value.find(v => v.trim() === '')
    if (whiteSpace) reject(new Error('Boşluklardan oluşan bir etiket tanımlanamaz.'))
    else resolve(value)
  })

export const cargoPriceRule = {
  pattern: /^\d+([.,]\d{1,2})?$/,
  message: 'Lütfen sıfırdan büyük bir kargo ücreti değeri giriniz.',
}
